var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionButtonBlocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "action-button-blocker",
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1647_18521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 30,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "action-button-blocker-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4912 0.113281L28.9912 24.1133H-0.00878906L14.4912 0.113281ZM14.4784 18.2243L14.3568 18.2277C13.2707 18.2898 12.4196 19.1782 12.4196 20.2494C12.4196 21.2972 13.2707 22.1841 14.3568 22.2461L14.4784 22.2495L14.6026 22.2461C15.6691 22.1865 16.497 21.3642 16.5591 20.3695L16.5628 20.2494L16.5594 20.1311C16.4971 19.0743 15.6058 18.2243 14.4784 18.2243ZM16.0446 8.66596H12.9378L13.347 16.7151H15.5605L16.0446 8.66596Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "action-button-blocker-2",
    mask: "url(#mask0_1647_18521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "action-button-blocker-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.5979 26.6276H31.5805V-2.40332H-2.5979V26.6276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "action-button-blocker-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.66968 30.8019H33.6512V-6.42773H-4.66968V30.8019Z",
    fill: "#151515",
    className: "icon-inside"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonBlocker);
export default __webpack_public_path__ + "static/media/action-button-blocker.b94f99031c48db770cd74848bc0b244e.svg";
export { ForwardRef as ReactComponent };